/**
 * Voice AI — Global Confirm Dialog
 * Single instance rendered in app-shell.js (top level = no stacking context issues).
 * Subscribes to confirmService and shows a <voice-modal> with confirm/cancel.
 */

import { LitElement, html } from 'lit';
import { designSystem, componentStyles } from '../styles/design-system.js';
import { iconStyles } from '../styles/icon-styles.js';
import { confirmService } from '../services/confirm-service.js';
import './voice-modal.js';

export class VoiceConfirmDialog extends LitElement {
  static properties = {
    _open: { state: true },
    _title: { state: true },
    _message: { state: true },
    _description: { state: true },
    _icon: { state: true },
    _iconColor: { state: true },
    _iconBg: { state: true },
    _confirmText: { state: true },
    _cancelText: { state: true },
    _confirmClass: { state: true },
  };

  static styles = [designSystem, componentStyles];

  constructor() {
    super();
    this._open = false;
    this._title = '';
    this._message = '';
    this._description = '';
    this._icon = 'fa-trash';
    this._iconColor = 'var(--color-error)';
    this._iconBg = 'rgba(239,68,68,0.1)';
    this._confirmText = 'Delete';
    this._cancelText = 'Cancel';
    this._confirmClass = 'btn-danger';
  }

  connectedCallback() {
    super.connectedCallback();
    confirmService.onStateChange(state => {
      if (state.open) {
        this._open = true;
        this._title = state.title;
        this._message = state.message;
        this._description = state.description;
        this._icon = state.icon;
        this._iconColor = state.iconColor;
        this._iconBg = state.iconBg;
        this._confirmText = state.confirmText;
        this._cancelText = state.cancelText;
        this._confirmClass = state.confirmClass;
      } else {
        this._open = false;
      }
    });
  }

  render() {
    return html`
      ${iconStyles}
      <voice-modal ?open=${this._open} title=${this._title} width="400px" z-index="1060"
        @modal-close=${() => confirmService.cancel()}>
        <div style="padding:var(--space-6);text-align:center;">
          <div style="width:56px;height:56px;border-radius:50%;background:${this._iconBg};display:flex;align-items:center;justify-content:center;margin:0 auto var(--space-4);">
            <i class="fa-sharp fa-light ${this._icon}" style="font-size:1.25rem;color:${this._iconColor};"></i>
          </div>
          ${this._message ? html`
            <div style="font-weight:var(--font-semibold);margin-bottom:var(--space-2);">${this._message}</div>
          ` : ''}
          ${this._description ? html`
            <div style="color:var(--color-text-secondary);font-size:var(--text-sm);">${this._description}</div>
          ` : ''}
        </div>
        <div slot="footer">
          <button class="btn btn-secondary" @click=${() => confirmService.cancel()}>${this._cancelText}</button>
          <button class="btn ${this._confirmClass}" @click=${() => confirmService.confirm()}>${this._confirmText}</button>
        </div>
      </voice-modal>
    `;
  }
}

customElements.define('voice-confirm-dialog', VoiceConfirmDialog);
